export enum RegistrantType {
  Pharmacist = 1,
  PharmacyTechnician = 2
}
